import type { CachedClient, XeroContactStatus } from '../db/jobsDb.js';

export function xeroStatusLabel(status: XeroContactStatus | undefined): string {
  switch (status) {
    case 'mapped':
      return 'In Xero';
    case 'conflict':
      return 'Name already in Xero';
    case 'failed':
      return 'Xero push failed';
    case 'pending':
      return 'Waiting to reach Xero';
    case 'unmapped':
    default:
      return 'Not in Xero yet';
  }
}

export function clientNeedsXeroAttention(c: CachedClient): boolean {
  if (c.pendingOp) return true;
  const s = c.xero_contact_status;
  return s === 'unmapped' || s === 'pending' || s === 'conflict' || s === 'failed';
}
